// components/feature/FloatingSupportButton.jsx
// ─────────────────────────────────────────────────────────────
// FIXED (this pass) — two changes:
//
// 1. ICON. Was a headset emoji (🎧), inconsistent with the rest of
//    this app's icon system, which uses Remix Icons throughout
//    (ri-arrow-left-line, ri-wifi-line, ri-checkbox-circle-fill, etc.
//    — see SupportEnquiryForm.jsx, DataPage.jsx, and essentially
//    every other component touched in this codebase). Switched to
//    ri-message-3-line, a chat-bubble icon, matching that convention
//    instead of standing out as the one emoji-based control in the app.
//
// 2. UNREAD BADGE. New — subscribes to useUnreadSupportCount() (see
//    hooks/useSupportNotifications.js) and renders a small numeric
//    badge on the button whenever there's an unread message the user
//    hasn't seen. This is what makes the floating button useful as an
//    AT-A-GLANCE indicator across the rest of the app, not just a
//    static launcher — a user on some unrelated page now has a
//    reason to notice it without needing the notification sound to
//    have caught their attention.
// ─────────────────────────────────────────────────────────────
import { useNavigate } from "react-router-dom";
import { useUnreadSupportCount } from "../../hooks/useSupportNotifications";

export default function FloatingSupportButton({ user }) {
  const navigate = useNavigate();
  const unreadCount = useUnreadSupportCount();

  if (!user) return null;

  return (
    <button
      onClick={() => navigate("/support")}
      className="fixed bottom-24 right-4 z-40 w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-transform active:scale-90 hover:scale-105"
      style={{ background: "var(--gradient-hero)" }}
      aria-label={unreadCount > 0 ? `Open support chat — ${unreadCount} unread message${unreadCount > 1 ? "s" : ""}` : "Open support chat"}
    >
      <i className="ri-message-3-line text-2xl text-white" />

      {/* FIXED — unread badge, new. Caps the displayed number at 9+
          rather than letting an arbitrarily large count blow out the
          badge's fixed size. */}
      {unreadCount > 0 && (
        <span
          className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full flex items-center justify-center text-[11px] font-bold text-white border-2"
          style={{ background: "var(--color-danger)", borderColor: "var(--color-bg)" }}
        >
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </button>
  );
}